module.exports = __webpack_public_path__ + "static/media/12.22dc6527.jpg";